import ComponentEx from 'components/ComponentEx';
import { getTxt } from 'global/appGlobal';
import { Dialog, DialogContent } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { EntityTypes, getEntityDescriptor } from 'global/entityDescriptors';
import { compose, graphql } from 'react-apollo';
import LinearProgressEx from '../../components/LinearProgressEx';
import c from '../../components/form/Components';
import MaterialForm from '../../components/form/MaterialForm';
import { DictionaryTypes, getDictionary, getLabel } from '../../global/dictionaryCache';
import { metadataQuery } from '../../home/Home';
import { authInfo, Roles } from '../../global/auth';
import GridEx from 'components/form/GridEx';

import * as queries from '../../modules/client/clientQueries';
import { Button } from '@material-ui/core';

let history;
let AfterSubmit;
const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing.unit * 2,
        margin: theme.spacing.unit * 2,
    },
    formButtons: {
        float: 'right',
        margin: '15px',
    },
    button: {
        margin: theme.spacing.unit,
    },
});


class Client_Payment_Edit extends ComponentEx {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);

    }

    state = {
        open: false,
    };

    formSetValues = { func: undefined };



    onSubmit(e, { obj, showErrors, hideErrors }) {
        const original = this.props.data.customerPayment;
        obj.customer_payment_id = original.customer_payment_id;

        this.props.updatePayment({
            variables: { customerPayment: obj },
            refetchQueries: [
                {
                    query: queries.customerPaymentByIdQuery,
                    variables: { id: this.props.editId },
                },
               
            ],
        }, this).then(
            (resp) => {
                hideErrors();
                if (resp.data.updateCustomerPaymentMutation &&
                    resp.data.updateCustomerPaymentMutation.validation &&
                    resp.data.updateCustomerPaymentMutation.validation.length > 0) {
                    showErrors(resp.data.updateCustomerPaymentMutation.validation);
                } else {
                    
                    AfterSubmit(resp.data.updateCustomerPaymentMutation.id);
                    //window.apolloClient.resetStore();
                }
            });
    }

    isChangeCustomerAllowed() {
        if (this.props.editId === 'new' && !this.props.customerId) {
            return true;
        }
        return false;
    }

    render() {

        const { classes } = this.props;

        const loading = this.props.data.loading;
        let item = this.props.data.customerPayment;
        history = this.props.history;
        AfterSubmit = this.props.AfterSubmit;

        const caption = (item && item.customer_payment_id !== '-1') ? getTxt('Edit Customer Payment') : getTxt('New Customer Payment');

        if (item && this.props.editId === 'new' && this.props.customerId) {
            item = { ...item };
            item.customer_id = this.props.customerId;
        }

        return (

            <Dialog onClose={() => { this.props.AfterSubmit(); }} open >
                <DialogContent>
                    <LinearProgressEx loading={loading} />


                    <Typography variant="h4" color="inherit" noWrap={false}>{caption}</Typography>

                    {item &&

                        <MaterialForm
                            dataSource={item}
                            objType={EntityTypes.CustomerPayment}
                            onSubmit={this.onSubmit}
                        >

                            {this.isChangeCustomerAllowed() && <c.field f="customer_id" ui="link-to-customer" />}
                            {!this.isChangeCustomerAllowed() && <c.field f="customer_id" ui="link-to-customer" d />}


                            <c.field l={getTxt('Payment Type')} f="payment_type_cd" ui="select" >
                                {getDictionary(DictionaryTypes.PublicPaymentType)}
                            </c.field>
                            <c.field l={getTxt('Payment State')} f="payment_state_cd" ui="select" >
                                {getDictionary(DictionaryTypes.InsuranceItemPaymentState)}
                            </c.field>
                            <c.field f="payment_account" ui="select" >
                                {getDictionary(DictionaryTypes.PaymentAccount)}
                            </c.field>
                            <c.field l={getTxt('Payment Date')} f="payment_date" />
                            <c.field l={getTxt('Payment notes')} f="payment_notes" />
                            <c.field f="payment_amount" />

                            <GridEx item sm={12} xs={12}>
                                <div className={classes.formButtons} >
                                    <Button
                                        className={classes.button}
                                        style={{marginRight: 10}}
                                        variant="contained"
                                        onClick={() => {
                                            this.props.AfterSubmit();
                                        }}
                                    >{getTxt('Annulla')}</Button>
                                    <Button
                                        color="primary"
                                        className={classes.button}
                                        type="submit"
                                        variant="contained"
                                    > {getTxt('Next')}</Button>
                                </div>

                            </GridEx>
                        </MaterialForm>

                    }

                </DialogContent>

            </Dialog>

        );
    }
}

export default compose(

    graphql(queries.customerPaymentByIdQuery, {
        options: props => (
            {
                variables: {
                    id: props.editId ? props.editId : 'new',
                },
                fetchPolicy: 'network-only',
                errorPolicy: 'all',
            }
        ),
    }),

    graphql(queries.updateCustomerPaymentMutation, {
        name: 'updatePayment',
        options: {
            errorPolicy: 'all',
           
        },
    }),

)(withStyles(styles)(Client_Payment_Edit));
